import React, { useState, useEffect } from 'react';
import './_categories.scss';
import CategoryCard from './CategoryCard';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PLP from 'components/web-feature/products/PLP';
import history from 'hb-redux-store/history';
import { anchorScroll } from '../../../MiscellaneousServices';

const Categories = props => {
  const {
    title = 'Search By Category',
    info,
    moreInfo = 'KNOW MORE',
    moreInfoActionUrl,
    deviceType,
    categories,
  } = props;
  const category = history.location.pathname.split('/')[1],
    isIncluded =
      props.categories &&
      props.categories.some(item => item.categoryName === category);
  const selectedPLP =
    category === '/'
      ? categories?.length && categories[0].categoryName
      : category;
  const defaultCategory =
    isIncluded && selectedPLP
      ? selectedPLP
      : categories?.length && categories[0].categoryName;
  const [selectedCategory, setCategory] = useState(defaultCategory);

  const isCategoriesLink = history.location.pathname !== '/';

  const setSelectedCategory = categoryName => {
    isCategoriesLink &&
      window.history.pushState(null, null, `/${categoryName}`);

    setCategory(categoryName);
    anchorScroll('.desktop-category-component', 100, 20);
  };
  // console.log('Categories: ',categories);
  // console.log('selectedPLP: ',selectedPLP);
  // console.log('selectedCategory: ', selectedCategory);
  // console.log('pathName: ', history.location.pathname);

  useEffect(() => {
    let category = history.location.pathname.split('/')[1],
      selectedPLP =
        category === '/'
          ? categories?.length && categories[0].categoryName
          : category;
    if (isCategoriesLink) setCategory(selectedPLP);
    else setCategory(categories?.length && categories[0].categoryName);
    // console.log('useEffect: ', category, selectedPLP, isCategoriesLink);
  }, [history.location.pathname]);
  return (
    <div
      className={`${
        isCategoriesLink
          ? 'desktop-categories-link--container'
          : 'desktop-category-component'
      }`}
    >
      <div
        className={`${
          isCategoriesLink ? 'desktop-categories-link--categories' : ''
        }`}
      >
        <div
          className={`${
            isCategoriesLink
              ? 'desktop-categories-link--title'
              : 'desktop-category-component--title'
          }`}
        >
          {title}
        </div>
        {info && (
          <div className="desktop-category-component--more-info">
            <div className="desktop-category-component--more-info--info">
              {info}
            </div>
            <Link
              to={moreInfoActionUrl}
              className="button action-link desktop-product-card--notify-me more"
            >
              {moreInfo}
            </Link>
          </div>
        )}
        <div>
          {categories.map(cat => (
            <CategoryCard
              category={cat}
              key={cat.categoryId}
              deviceType={deviceType}
              getSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
              isCategoriesLink={isCategoriesLink}
            />
          ))}
        </div>
      </div>
      <div className="section-divider--white"></div>
      <div
        className={`${isCategoriesLink ? 'desktop-categories-link--list' : ''}`}
      >
        {isCategoriesLink && isIncluded && (
          <div className="desktop-categories-link--main">{`${selectedCategory}`}</div>
        )}
        <PLP category={selectedCategory} />
      </div>
    </div>
  );
};

Categories.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.array.isRequired,
  info: PropTypes.string,
  moreInfo: PropTypes.string,
  moreInfoActionUrl: PropTypes.string,
  deviceType: PropTypes.string,
};

export default Categories;
